var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bydate-wrapper"},[_c('datepicker',{attrs:{"disabledDates":_vm.disabledDates,"placeholder":"Select Date","name":"inputKenoDate","format":_vm.customFormatter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }